import React from "react";
import { observer, inject } from "mobx-react";

import Alert from "./_common/alert";
import SurveyContainer from "./survey";
import UserContainer from "./user";
import GroupContainer from "./group";
import StartContainer from "./start";
import Navigation from "./navigation";
import * as M from "@material-ui/core";
import UserRegister from "./user-register";
import UserSignin from "./user-signin";
import UserPasswordReset from "./user-password-reset";
import Boarding from "./boarding";
import DisclaimerInfo from "./disclaimer-info";
import LanguageSwitcher from "./_common/language-switcher";

const App = ({ store }) => {
  const { $router, $user, $loading, $config, $locale, $survey } = store;
  const classes = [
    "page-" + $router.page,
    !$user.sessionUser.isVerifiedMentor && "container",
    $router.mode && "mode-" + $router.mode,
    $user.sessionUser.isVerifiedMentor ? "private" : "public",
    $locale.activeLocaleDirection
  ];
  return (
    <React.Fragment>
      <Alert />
      {!$loading ? (
        <div className={classes.join(" ")}>
          {$user.sessionUser.isVerifiedMentor ? (
            <Navigation type="main" />
          ) : (
            <header className="flex justify-between pt-16 pb-8">
              {$config.logo && (
                <div className="logo">
                  <h1 className="font-semibold">{$config.logo}</h1>
                </div>
              )}
              <div className="flex items-center">
                {$user.sessionUser.email && (
                  <span className="color-white mr-4">
                    {$user.sessionUser.email}{" "}
                    {!$user.sessionUser.emailVerified && "- Uw emailadres is nog niet bevestigd"}
                  </span>
                )}
                <M.Button
                  onClick={() => {
                    $user.sessionUser.email ? $user.signOut() : $user.change("enableSignIn", true);
                  }}
                >
                  {$user.sessionUser.email ? "Logout" : "Login"}
                </M.Button>
                {$router.mode === "view" && $survey.selected && (
                  <LanguageSwitcher
                    className="ml-2"
                    languages={$survey.selected.languages.split(",")}
                  />
                )}
                {$router.mode !== "view" && $config.multilanguage_app && (
                  <LanguageSwitcher
                    className="ml-2"
                    languages={$config.languages.map(l => l.key)}
                  />
                )}
              </div>
            </header>
          )}
          <main>
            {$router.page === "survey" && <SurveyContainer />}
            {$router.page === "user" && <UserContainer />}
            {$router.page === "group" && <GroupContainer />}
            {$router.page === "start" && <StartContainer />}
          </main>
          <UserRegister />
          <UserSignin />
          <UserPasswordReset />
          {$user.sessionUser.isVerifiedMentor && !$user.sessionUser.isVerifiedCreator && (
            <Boarding />
          )}
          {$user.sessionUser.showDisclaimerInfo && <DisclaimerInfo />}
        </div>
      ) : (
        <div className="flex items-center justify-center h-screen w-screen">
          <M.CircularProgress />
        </div>
      )}
      <div
        className="bg-gray bg-fixed bg-cover w-full fixed top-0 left-0"
        style={{
          zIndex: -1,
          backgroundImage: "url(/assets/images/" + $config.background + ")"
        }}
      ></div>
    </React.Fragment>
  );
};

export default inject("store")(observer(App));
